// For old rentals view
export let stopBookedRentalsListener: () => void = () => undefined;
export let stopActiveRentalsListener: () => void = () => undefined;
export let stopCompletedRentalsListener: () => void = () => undefined;

// For old rental view

export const setStopActiveRentalsListener = (stopFunction: () => void) => {
	stopActiveRentalsListener = stopFunction;
};

export const setStopBookedRentalsListener = (stopFunction: () => void) => {
	stopBookedRentalsListener = stopFunction;
};

export const setStopCompletedRentalsListener = (stopFunction: () => void) => {
	stopCompletedRentalsListener = stopFunction;
};
